import { useMemo } from "react";
import { useLoyaltyAchievements, useReferralStats } from "@jti/rest-api";
import { useUser } from "../../../../hooks/useUser";
const TARGET_EVENTS = [
    "referrer_network_first_purchase",
    "referrer_network_purchase",
    "referrers_affiliate_registered",
];
export const useUserReferralData = () => {
    const { user } = useUser();
    const { isLoading: isLoyaltyStatisticLoading, data: loyaltyStatisticsData, error: loyaltyStatisticsError, } = useReferralStats({
        uuid: user?.uuid,
        ciam_token: user?.ciam_token,
    });
    const { data: achievements, isLoading: isAchievementsLoading, error: achievementsError, } = useLoyaltyAchievements({
        uuid: user?.uuid,
        ciam_token: user?.ciam_token,
    });
    const { friendsReferralsUntilNextAchievement, isAllAchievementsDone, milestones, totalUserReferrals } = useMemo(() => {
        const relevantAchievements = achievements?.items
            .filter(({ rules }) => rules.length !== 0 && TARGET_EVENTS.includes(rules[0].custom_event))
            .sort((cur, next) => {
            return cur.rules[0].goal - next.rules[0].goal;
        });
        if (!relevantAchievements || relevantAchievements.length <= 0) {
            return {
                friendsReferralsUntilNextAchievement: 0,
                totalUserReferrals: 0,
                isAllAchievementsDone: false,
                milestones: [],
            };
        }
        const currentAchievementIndex = relevantAchievements.findIndex(({ completed_count }) => !completed_count);
        const isAllAchievementsDone = currentAchievementIndex === -1;
        const currentAchievement = relevantAchievements[isAllAchievementsDone ? relevantAchievements.length - 1 : currentAchievementIndex];
        const { rules: [{ goal: currentGoal, value: currentValue }], } = currentAchievement;
        const friendsReferralsUntilNextAchievement = currentGoal - currentValue;
        const milestones = relevantAchievements.map(({ rules: [{ goal, points_value }] }) => ({
            referralNumber: goal,
            mileStonePointsValue: points_value,
        }));
        const maxReferralNumber = Math.max(...milestones.map((milestone) => milestone.referralNumber));
        return {
            milestones,
            isAllAchievementsDone,
            friendsReferralsUntilNextAchievement,
            totalUserReferrals: isAllAchievementsDone ? maxReferralNumber : currentValue,
        };
    }, [achievements]);
    return {
        milestones,
        isAllAchievementsDone,
        friendsReferralsUntilNextAchievement,
        totalUserReferrals,
        referredFriendsCountForStatistics: loyaltyStatisticsData?.completed_first_order_count,
        pointsEarned: loyaltyStatisticsData?.earned_points,
        isLoading: isLoyaltyStatisticLoading || isAchievementsLoading,
        isComponentHidden: !achievements || !loyaltyStatisticsData || !!loyaltyStatisticsError || !!achievementsError,
    };
};
//# sourceMappingURL=useUserReferralData.js.map